const firstTheme = {
    screenbg: "hsl(224, 36%, 15%)",
    keycolor: "hsl(221, 14%, 31%)",
    color: "hsl(0, 0%, 100%)",
    sliderBg: "hsl(223, 31%, 20%)",
    keypadBg: "hsl(223, 31%, 20%)",
    mainBg: "hsl(222, 26%, 31%)",
    delBg: "hsl(225, 21%, 49%)",
    delShadow: "hsl(224, 28%, 35%)",
    equalBg: "hsl(6, 63%, 50%)",
    equalShadow: "hsl(6, 70%, 34%)",
    keyBg: "hsl(30, 25%, 89%)",
    keyShadow: "hsl(28, 16%, 65%)",
    equalcolor: "hsl(0, 0%, 100%)"
  };
  
  const secondTheme = {
    screenbg: "hsl(0, 0%, 93%)",
    keycolor: "hsl(60, 10%, 19%)",
    color: "hsl(60, 10%, 19%)",
    sliderBg: "hsl(0, 5%, 81%)",
    keypadBg: "hsl(0, 5%, 81%)",
    mainBg: "hsl(0, 0%, 90%)",
    delBg: "hsl(185, 42%, 37%)",
    delShadow: "hsl(185, 58%, 25%)",
    equalBg: "hsl(25, 98%, 40%)",
    equalShadow: "hsl(25, 99%, 27%)",
    keyBg: "hsl(45, 7%, 89%)",
    keyShadow: "hsl(35, 11%, 61%)",
    equalcolor: "hsl(0, 0%, 100%)"
  };

  const thirdTheme = {
    screenbg: "hsl(268, 71%, 12%)",
    keycolor: "hsl(52, 100%, 62%)",
    color: "hsl(52, 100%, 62%)",
    sliderBg: "hsl(268, 71%, 12%)",
    keypadBg: "hsl(268, 71%, 12%)",
    mainBg: "hsl(268, 75%, 9%)",
    delBg: "hsl(281, 89%, 26%)",
    delShadow: "hsl(285, 91%, 52%)",
    equalBg: "hsl(176, 100%, 44%)",
    equalShadow: "hsl(177, 92%, 70%)",
    keyBg: "hsl(268, 47%, 21%)",
    keyShadow: "hsl(290, 70%, 36%)",
    equalcolor: "hsl(198, 20%, 13%)"
  };
  
  export const themes = {
    first: firstTheme,
    second: secondTheme,
    third: thirdTheme
  };
  